var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"content mb-3"},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"text-center mt-3"},[_c('h2',[_vm._v("Abwesenheitsverwaltung")])])],1),_vm._v(" "),_c('Calendar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }